var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',_vm._g(_vm._b({attrs:{"variant":"primary","size":"sm"}},'b-button',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('span',[_vm._v(_vm._s(_vm.type === 'xlsx' ? 'XLSX' : 'CSV'))]),(_vm.showCount)?void 0:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }